import { axiosInstance } from '~/services';

import type {
  TypeGetOwnerSupplierBusinessNumberExistsParams,
  TypeGetOwnerSupplierBusinessNumberExistsResponse,
} from '~/types/vender.types';

/**
 * [화주사정보관리 > 공급사관리] 공급사 사업자번호 중복 체크 조회
 */
const useGetOwnerSupplierBusinessNumberExists = () => {
  const endPoint = '/api-owner/owner-supplier';

  const getOwnerSupplierBusinessNumberExists = async ({
    businessNumber,
  }: TypeGetOwnerSupplierBusinessNumberExistsParams) => {
    return axiosInstance
      .get<TypeGetOwnerSupplierBusinessNumberExistsResponse>(`${endPoint}/${businessNumber}/exists`)
      .then(({ data }) => {
        return data.data;
      })
      .catch((error) => {
        throw error;
      });
  };

  return { getOwnerSupplierBusinessNumberExists };
};

export default useGetOwnerSupplierBusinessNumberExists;
